import React from "react";
import { cn } from "../../utils/helpers";
interface HeaderContainerProps {
  children?: React.ReactNode;
  styles: Array<string>;
}
export const HeaderContainer = ({ children, styles = [] }: HeaderContainerProps) => {
  return <div className={cn("flex flex-col items-start py-4 px-2", styles)}>{children}</div>;
};
